var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuLeft',{attrs:{"menuTops":_vm.mainMenu}}),_c('div',{staticClass:"main-container"},[_c('router-view',{staticStyle:{"height":"100%"}})],1),_c('snackbar-vue'),_c('loading-message-vue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }